import MainIcons from '@/icons/main';
import styles from './styles.module.css';

type Commitment = {
  title: string;
  description: string;
};

const commitments: Commitment[] = [
  {
    title: 'ضمانت اصالت',
    description: 'در صورت اثبات تقلبی بودن، سه برابر بازپرداخت.',
  },
  {
    title: 'مرجوعی ۷ روزه',
    description: 'کالای بازنشده تا یک هفته قابل بازگشت است.',
  },
  {
    title: 'ارسال همان‌روز تهران',
    description: 'برای سفارش‌های پیش از ساعت ۱۵.',
  },
  {
    title: 'مشاورهٔ فنی',
    description: 'انتخاب قطعهٔ سازگار با خودروی شما.',
  },
];

export default function ShopCommitments() {
  return (
    <section className={styles.container}>
      <h2 className={styles.heading}>تعهدات این فروشگاه</h2>

      <div className={styles.grid}>
        {commitments?.map((item) => (
          <div key={item.title} className={styles.card}>
            <span className={styles.icon}>
              <MainIcons.shieldIcon fill="var(--green)" width="16px" height="16px" />
            </span>

            <div>
              <div className={styles.title}>{item.title}</div>
              <div className={styles.description}>{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
